import Axios from "axios";
import Login from "../assets/js/login";
import store from "../store/index.js";
import {
	Message
} from 'element-ui';

/* eslint-disable */
// const VISION_URL = "http://121.40.214.203:13149/gateway/olduflyvision/";
// const PLAT_URL = "http://121.40.214.203:13149/gateway/oldvisualplat/";
// const AUTH_URL = "http://121.40.214.203:13149/gateway/auth/";
// const TRAIN_URL = "http://121.40.214.203:13149/gateway/training/";
// const GAME_URL = "http://121.40.214.203:13149/gateway/game/";
// const BACKSTAGE_URL = "http://121.40.214.203:13149/backstage/";
// const WECHAT_URL = "http://121.40.214.203:13149/gateway/wechat/";
// const LOG_URL = "http://121.40.214.203:13149/gateway/log/";
// const LI_URL = 'https://api00.uflycloud.com/';

// 正式域名
const VISION_URL = 'https://api00.uflycloud.com:13149/gateway/olduflyvision/';
const PLAT_URL = 'https://api00.uflycloud.com:13149/gateway/oldvisualplat/';
const AUTH_URL = 'https://api00.uflycloud.com:13149/gateway/auth/';
const TRAIN_URL = 'https://api00.uflycloud.com:13149/gateway/training/';
const GAME_URL = 'https://api00.uflycloud.com:13149/gateway/game/';
const BACKSTAGE_URL = 'https://api00.uflycloud.com:8092/backstage/';
const WECHAT_URL = 'https://api00.uflycloud.com:13149/gateway/wechat/';
const LOG_URL = 'https://api00.uflycloud.com:13149/gateway/log/';
const LI_URL = 'https://api00.uflycloud.com/';
// const LI_URL_TRAIN = 'http://192.168.11.188:8094/';//老胡本地
const LI_URL_TRAIN = 'https://api00.uflycloud.com:8094/';
const LI_URL_APP = 'https://api00.uflycloud.com:8096/';
// const LI_URL_APP = 'http://192.168.11.33:8096/';

const LI_URL_KDSL = 'https://api00.uflycloud.com:8098/';
// const LI_URL_KDSL = 'http://192.168.11.27:8098/';

// 设置请求超时时间
Axios.defaults.timeout = 15000;

/**
 * @description get请求
 * url{String} 请求路径
 * obj{Object} 请求参数
 * isAuth{Boolean} 是否需要校验
 * */
const getHttp = (url, obj, isAuth) => {
	// let getData = "";
	let config = {};
	// let request_url = url;
	if (isAuth) {
		config = {
			headers: {
				'serverFlag': '',
				'content-type': 'application/json;charset=UTF-8',
				'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
				'accessToken': store.state.safeInfo.kt
			},
			method: 'get',
			baseURL: '/',
			params: obj
		};
	} else {
		config = {
			headers: {
				'serverFlag': '',
				'content-type': 'application/json;charset=UTF-8'
			},
			method: 'get',
			baseURL: '/',
			params: obj
		};
	}
	// for (let k in obj) {
	// 	getData += `${ k }=${ obj[k] }&`;
	// }

	// if (getData) {
	// 	getData = `?${ getData }`;
	// 	getData = getData.slice(0, getData.length - 1);
	// 	request_url += getData;
	// }
	return new Promise((resolve, reject) => {
		Axios.get(url, config).then((res) => {
			if (res.data.code == 10324) {
				refreshToken(() => {
					getHttp(url, obj, isAuth).then((rt) => {
						resolve(rt);
					}, (e) => {
						reject({
							message: e.errMsg
						});
					});
				});
			} else if (res.data.code == 408 || res.data.code == 10314 || res.data.code == 10315 ||
				res.data.code == 10316 || res.data.code == 10317 || res.data.code == 10325 || res
				.data.code == 10326) {
				Message.warning("登录异常，请重新登录！");
				setTimeout(() => {
					Login.exit();
					window.location.replace(`${ location.origin }/login`);
				}, 1500);
			} else {
				resolve(res);
			}
		}).catch((e) => {
			reject({
				message: e.errMsg
			});
		});
	});
}

/**
 * @description delete请求
 * url{String} 请求路径
 * obj{Object} 请求参数
 * isAuth{Boolean} 是否需要校验
 * */
const deleteHttp = (url, obj, isAuth) => {
	// let deleteData = "";
	let config = {};
	// let request_url = url;
	if (isAuth) {
		config = {
			headers: {
				'serverFlag': '',
				'content-type': 'application/json;charset=UTF-8',
				'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
				'accessToken': store.state.safeInfo.kt
			},
			method: 'delete',
			baseURL: '/',
			params: obj
		};
	} else {
		config = {
			headers: {
				'serverFlag': '',
				'content-type': 'application/json;charset=UTF-8'
			},
			method: 'delete',
			baseURL: '/',
			params: obj
		};
	}
	// for (let k in obj) {
	// 	deleteData += `${ k }=${ obj[k] }&`;
	// }

	// if (deleteData) {
	// 	deleteData = `?${ deleteData }`;
	// 	deleteData = deleteData.slice(0, deleteData.length - 1);
	// 	request_url += deleteData;
	// }
	return new Promise((resolve, reject) => {
		Axios.delete(url, config).then((res) => {
			if (res.data.code == 10324) {
				refreshToken(() => {
					deleteHttp(url, obj, isAuth).then((rt) => {
						resolve(rt);
					}, (e) => {
						reject({
							message: e.errMsg
						});
					});
				});
			} else if (res.data.code == 408 || res.data.code == 10314 || res.data.code == 10315 ||
				res.data.code == 10316 || res.data.code == 10317 || res.data.code == 10325 || res
				.data.code == 10326) {
				Message.warning("登录异常，请重新登录！");
				setTimeout(() => {
					Login.exit();
					window.location.replace(`${ location.origin }/login`);
				}, 1500);
			} else {
				resolve(res);
			}
		}).catch((e) => {
			reject({
				message: e.errMsg
			});
		});
	});
}

/**
 * @description post请求
 * url{String} 请求路径
 * obj{Object} 请求参数
 * isAuth{Boolean} 是否需要校验
 * isJson{Boolean} 请求参数是否是JSON类型
 * */
const postHttp = (url, obj, isAuth, isJson) => {
	// window.console.log(store.state.kf_web_loginInfo);
	let postData = "";
	let config = {};
	if (isAuth) {
		if (url == `${ AUTH_URL }getRefreshToken`) {
			config = {
				headers: {
					'serverFlag': '',
					'content-type': 'application/x-www-form-urlencoded',
					'refreshToken': `Bearer ${ store.state.safeInfo.kj }`,
					'accessToken': store.state.safeInfo.kt
				},
				method: "post",
				baseURL: '/'
			};
		} else {
			isJson
				?
				(config = {
					headers: {
						'serverFlag': '',
						'content-type': 'application/json;charset=UTF-8',
						'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
						'accessToken': store.state.safeInfo.kt
					},
					method: 'post',
					baseURL: '/'
				}) :
				(config = {
					headers: {
						'serverFlag': '',
						'content-type': 'application/x-www-form-urlencoded',
						'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
						'accessToken': store.state.safeInfo.kt
					},
					method: 'post',
					baseURL: '/'
				});
		}
	} else {
		isJson
			?
			(config = {
				headers: {
					'serverFlag': '',
					'Authorization': 'Basic S2ZXZWJBcHA6S2ZXZWJBcHA=',
					'content-type': 'application/json;charset=UTF-8'
				},
				method: 'post',
				baseURL: '/'
			}) :
			(config = {
				headers: {
					'serverFlag': '',
					'Authorization': 'Basic S2ZXZWJBcHA6S2ZXZWJBcHA=',
					'content-type': 'application/x-www-form-urlencoded'
				},
				method: 'post',
				baseURL: '/'
			});
	}
	if (!isJson) {
		for (let k in obj) {
			postData += `${ k }=${ obj[k] }&`;
		}
		postData && (postData = postData.slice(0, postData.length - 1));
	} else {
		postData = obj;
	}
	return new Promise((resolve, reject) => {
		Axios.post(url, postData, config).then((res) => {
			if (res.data.code == 10324) {
				refreshToken(() => {
					postHttp(url, obj, isAuth, isJson).then((rt) => {
						resolve(rt);
					}, (e) => {
						reject({
							message: e.errMsg
						});
					});
				});
			} else if (res.data.code == 408 || res.data.code == 10314 || res.data.code == 10315 ||
				res.data.code == 10316 || res.data.code == 10317 || res.data.code == 10325 || res
				.data.code == 10326) {
				Message.warning("登录异常，请重新登录！");
				setTimeout(() => {
					Login.exit();
					window.location.replace(`${ location.origin }/login`);
				}, 1500);
			} else {
				resolve(res);
			}
		}).catch((e) => {
			reject({
				message: e.errMsg
			});
		});
	});
}

/**
 * @description put请求
 * url{String} 请求路径
 * obj{Object} 请求参数
 * isAuth{Boolean} 是否需要校验
 * isJson{Boolean} 请求参数是否是JSON类型
 * */
const putHttp = (url, obj, isAuth, isJson) => {
	let putData = "";
	let config = {};
	if (isAuth) {
		isJson
			?
			(config = {
				headers: {
					'serverFlag': '',
					'content-type': 'application/json;charset=UTF-8',
					'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
					'accessToken': store.state.safeInfo.kt
				},
				method: "put",
				baseURL: '/'
			}) :
			(config = {
				headers: {
					'serverFlag': '',
					'content-type': 'application/x-www-form-urlencoded',
					'Authorization': `Bearer ${ store.state.safeInfo.kj }`,
					'accessToken': store.state.safeInfo.kt
				},
				method: "put",
				baseURL: '/'
			});
	} else {
		isJson
			?
			(config = {
				headers: {
					'serverFlag': '',
					'content-type': 'application/json;charset=UTF-8'
				},
				method: "put",
				baseURL: '/'
			}) :
			(config = {
				headers: {
					'serverFlag': '',
					'content-type': 'application/x-www-form-urlencoded'
				},
				method: 'put',
				baseURL: '/'
			});
	}
	if (!isJson) {
		for (let k in obj) {
			putData += `${ k }=${ obj[k] }&`;
		}
		putData && (putData = putData.slice(0, putData.length - 1));
	} else {
		putData = obj;
	}
	return new Promise((resolve, reject) => {
		Axios.put(url, putData, config).then((res) => {
			if (res.data.code == 10324) {
				refreshToken(() => {
					putHttp(url, obj, isAuth, isJson).then((rt) => {
						resolve(rt);
					}, (e) => {
						reject({
							message: e.errMsg
						});
					});
				});
			} else if (res.data.code == 408 || res.data.code == 10314 || res.data.code == 10315 ||
				res.data.code == 10316 || res.data.code == 10317 || res.data.code == 10325 || res
				.data.code == 10326) {
				Message.warning("登录异常，请重新登录！");
				setTimeout(() => {
					Login.exit();
					window.location.replace(`${ location.origin }/login`);
				}, 1500);
			} else {
				resolve(res);
			}
		}).catch((e) => {
			reject({
				message: e.errMsg
			});
		});
	});
}

// 刷新Token，当token过期时重新登录
/* eslint-disable */
function refreshToken(success) {
	var code = store.state.loginInfo.code,
		obj = {
			type: "backstage"
		};
	Api.refreshToken(obj).then((res) => {
		if (res.data.success) {
			var kj = res.headers.ttkj,
				kt = res.headers.ttkt;
			Login.setSafeInfo(kj, kt);
			Login.setSafeInfoCache(kj, kt);
			success && success();
		} else {
			Message.warning("请求异常，请重新登录！");
			setTimeout(() => {
				Login.exit();
				window.location.replace(`${ location.origin }/login`);
			}, 1500);
		}
	}, (e) => {
		Message.warning("请求异常，请重新登录！");
		setTimeout(() => {
			Login.exit();
			window.location.replace(`${ location.origin }/login`);
		}, 1500);
	});
}

export default class Api {
	// 登录接口
	static login(obj) {
		return postHttp(`${ LI_URL }oauth/token`, obj, false, false);
	}

	// 刷新token
	static refreshToken(obj) {
		return postHttp(`${ AUTH_URL }getRefreshToken`, obj, true, false);
	}

	// 发送验证码
	static sendCode(obj) {
		return postHttp(`${ GAME_URL }sendMessCodeByType`, obj);
	}

	// // 用户修改密码
	// static updatePassword(obj) {
	// 	return postHttp(`${ GAME_URL }updatePasswordByType`, obj, false, true);
	// }
	// bb

	// 用户修改密码
	static updatePassword(obj) {
		return postHttp(`${ LI_URL }compatible/old/admin/updatePasswordByType`, obj, true, true);
	}



	// 充值
	static recharge(obj) {
		return postHttp(`${ LI_URL }compatible/old/admin/addTotalRecharge`, obj, true, true);
	}

	// 充值消费记录
	static getOrganizationRechargeConsumeRecord(obj) {
		return postHttp(`${ VISION_URL }underline/findAllConsumption`, obj, true, true);
	}


	// 查看邀请好友注册列表
	// static fuYangadmin(id) {
	// 	return getHttp(`${ LI_URL }front/wUser/fuYang/admi/${ id }`, true);
	// }
	static fuYangadmin(obj) {
		return getHttp(`${ LI_URL }front/wUser/fuYang/admin`, obj, true);
	}



	// 获取所有产品及子产品
	static findProductType(obj) {
		return getHttp(`${ LI_URL_TRAIN }compatible/old/findMissionType`, obj, true);
	}


	// // 获取所有产品及子产品
	// static findProductType(obj) {
	// 	return getHttp(`${ TRAIN_URL }findMissionType`, obj, true);
	// }
	// 获取登录者所有产品
	static findAuthProduct(obj) {
		return postHttp(`${ LI_URL_TRAIN }compatible/old/admin/patientUnderlineProducts`, obj, true, false);
	}

	// 获取所有机构列表
	static findOrganizations() {
		return getHttp(`${ LI_URL }admin/enterprise/list`, {}, true);
	}

	// 获取权限列表
	static findPermission() {
		return getHttp(`${ LI_URL }admin/priviledge/list`, {}, true);
	}

	// 获取用户信息(主要针对登录)
	static findUserInfo(obj) {
		return getHttp(`${ BACKSTAGE_URL }business/findUserIdentity`, obj, true);
	}

	// 获取用户详细信息
	static findUserDetailInfo(obj) {
		return getHttp(`${ VISION_URL }underline/findUserInfo`, obj, true, false);
	}

	// 获取所有病理类型
	static findAllDisease(obj) {
		return getHttp(`${ BACKSTAGE_URL }business/findAllDiseases`, obj, false);
	}

	// 获取医生的病理类型
	static findDiseaseByDoctor(obj) {
		return getHttp(`${ LI_URL }admin/buser/userDisease`, obj, true);
	}

	// 上传图片
	static uploadPic(obj) {
		return postHttp(`${ GAME_URL }loadPic`, obj, true, true);
	}

	// 根据账号实时查询
	static findDoctorsByCode(obj) {
		return getHttp(`${ BACKSTAGE_URL }findUserByFuzzyQuery`, obj, true);
	}

	// 查询组织机构
	static findOrganization(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/findEenterpriseByConditions`, obj, true, true);
	}

	// 新增组织机构
	static addOrganization(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/openNewMechanismKeFei`, obj, true, true);
		// return postHttp(`http://192.168.11.188:10410/backstage/business/openNewMechanismKeFei`, obj, true, true);
	}

	// 修改组织机构
	static updateOrganization(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/updateMechanism`, obj, true, true);
	}

	// 删除组织机构
	static deleteOrganization(obj) {
		return putHttp(`${ BACKSTAGE_URL }business/deleteMechanism`, obj, true, false);
	}

	// 查询组织机构管理员
	static findOrganizationManager(obj) {
		return getHttp(`${ BACKSTAGE_URL }business/findAdministrators`, obj, true);
	}

	// 组织机构消费统计
	static getOrganizationConsumeCount(obj) {
		return getHttp(`${ VISION_URL }underline/findEnterpriseAccount`, obj, true);
	}

	// 查询用户
	static findUser(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/findUserByConditions`, obj, true, true);
	}

	// 新增用户
	static addUser(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/openNewUsers`, obj, true, true);
	}

	// 修改用户
	static updateUser(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/updateUserByConditions`, obj, true, true);
	}

	// 删除用户
	static deleteUser(obj) {
		return putHttp(`${ BACKSTAGE_URL }business/deleteUser`, obj, true, false);
	}

	// 根据区域获取所有机构
	static findFirmsByArea(obj) {
		return getHttp(`${ BACKSTAGE_URL }business/findUEenterprises`, obj, true);
	}

	// 获取用户训练记录
	static findUserTrainingRec(obj) {
		return postHttp(`${ TRAIN_URL }findTotalTrainingRec`, obj, true, true);
	}

	// 获取用户训练记录图表数据
	static findUserTrainingChartData(obj) {
		return postHttp(`${ TRAIN_URL }findTrainingRecCareFul`, obj, true, true);
	}

	// 获取正确率统计
	static findUserCorrectRate(obj) {
		return getHttp(`${ TRAIN_URL }findBlockAccs`, obj, true);
	}

	// 获取用户处方
	static findAgentPrescription(obj) {
		return getHttp(`https://api00.uflycloud.com:8094/compatible/old/admin/findAgentPrescription`, obj, true);
	}

	// 修改用户处方
	static updateUserPrescription(obj) {
		return postHttp(`${ TRAIN_URL }updatePrescriptionById`, obj, true, true);
	}

	// 修改任务
	static updateUserTask(obj) {
		return postHttp(`${ TRAIN_URL }updateProductPatientRelative`, obj, true, true);
	}

	// // 获取用户开通产品
	// static getUserProducts(obj) {
	// 	return postHttp(`${ TRAIN_URL }getAProductsByInputPhoneNum`, obj, true, false);
	// }


	// 获取用户开通产品
	static getUserProducts(obj) {
		return postHttp(`${ LI_URL_TRAIN }compatible/old/admin/getAProductsByInputPhoneNum`, obj, true, false);
	}

	// // 用户开通产品
	// static openUserProduct(obj) {
	// 	return postHttp(`${ TRAIN_URL }productOpening_`, obj, true, false);
	// }


	// 用户开通产品
	static openUserProduct(obj) {
		return postHttp(`${ LI_URL_TRAIN }compatible/old/admin/productOpening_`, obj, true, false);
	}

	// 获取机构下的医生
	static findDoctorsByForm(obj) {
		return postHttp(`${ VISION_URL }underline/findTotalAllDoctors`, obj, true, true);
	}

	// 获取用户的回访信息
	static findUserRevisits(obj) {
		return getHttp(`${ BACKSTAGE_URL }business/findAllUReturnVisit`, obj, true);
	}

	// 新增用户的回访信息
	static addUserRevisit(obj) {
		return postHttp(`${ BACKSTAGE_URL }business/addUReturnVisit`, obj, true, true);
	}

	// 删除用户的回访信息
	static deleteUserRevisit(obj) {
		return putHttp(`${ BACKSTAGE_URL }business/deleteUReturnVisit`, obj, true, false);
	}

	// 获取用户病历列表
	static findUserMedicals(obj) {
		return getHttp(`${ BACKSTAGE_URL }medical/findAllMedicalRecords`, obj, true);
	}

	// 获取用户病历
	static findUserMedical(obj) {
		return getHttp(`${ GAME_URL }getPicUrlByType`, obj, true);
	}

	// 获取用户健康档案列表
	static findUserDocs(obj) {
		return getHttp(`${ BACKSTAGE_URL }medical/getCheckDocumentList`, obj, true);
	}

	// 获取用户健康档案
	static findUserDoc(obj) {
		return getHttp(`${ BACKSTAGE_URL }medical/getCheckDocumentById`, obj, true);
	}

	// 获取训练记录筛选数据
	static findTrainingFilterData(obj) {
		return getHttp(`${ TRAIN_URL }findMissionTypeByUserId`, obj, true);
	}

	// 我的信息
	static findAuthDetail(obj) {
		return postHttp(`${ LI_URL }compatible/old/admin/underlineInfo`, obj, true, false);
	}

	// 查询消费记录
	static findFinanceCountConsumeRecord(obj) {
		return postHttp(`${ BACKSTAGE_URL }data/findAllConsumption`, obj, true, true);
	}

	// 报表查询
	static finduserConsumptionData(obj) {
		return getHttp(`${ LI_URL }statistics/userConsumption`, obj, true);
	}


	// 代理商报表查询
	static findagentConsumptionData(obj) {
		return getHttp(`${ LI_URL }statistics/agentConsumption`, obj, true);
	}


	// 机构报表查询
	static finduserhosConsumptionData(obj) {
		return getHttp(`${ LI_URL }statistics/hosConsumption`, obj, true);
	}


	// 获取用户统计账户监控数据
	static findUserCountAccountMonitoring(obj) {
		return postHttp(`${ BACKSTAGE_URL }data/monitorUserAccount`, obj, true, true);
	}

	// 获取用户统计训练监控数据
	static findUserCountTrainingMonitoring(obj) {
		return postHttp(`${ BACKSTAGE_URL }data/findUserTraining`, obj, true, true);
	}

	// 根据机构名称查询机构
	static findFirmsByName(obj) {
		return getHttp(`${ BACKSTAGE_URL }data/findEnterpriseByName`, obj, true);
	}

	// 根据机构名称模糊查询机构
	static queryFirmsByName(obj) {
		return getHttp(`${ BACKSTAGE_URL }data/findEnterpriseIdByName`, obj, true);
	}

	// 获取登录类型
	static findLoginType(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findAllLoginTypes`, obj, true);
	}

	// 新增登录类型
	static addLoginType(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/addLoginType`, obj, true, true);
	}

	// 修改登录类型
	static updateLoginType(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/updateLoginType`, obj, true, true);
	}

	// 删除登录类型
	static deleteLoginType(obj) {
		return putHttp(`${ BACKSTAGE_URL }utils/deleteLoginType`, obj, true, false);
	}

	// 获取激活卡
	static findActiveCard(obj) {
		return getHttp(`${ TRAIN_URL }findActivationCard`, obj, true);
	}

	// 新增激活卡
	static addActiveCard(obj) {
		return postHttp(`${ TRAIN_URL }addActivationCard`, obj, true, true);
	}

	// 修改激活卡
	static updateActiveCard(obj) {
		return postHttp(`${ TRAIN_URL }updateActivationCard`, obj, true, true);
	}

	// 删除激活卡
	static deleteActiveCard(obj) {
		return putHttp(`${ TRAIN_URL }deleteActivationCard`, obj, true, false);
	}

	// 获取产品类型
	static findProductCategory(obj) {
		return postHttp(`${ TRAIN_URL }findAllTrainingProducts`, obj, true, false);
	}

	// 新增产品类型
	static addProductCategory(obj) {
		return postHttp(`${ TRAIN_URL }addAllProducts`, obj, true, true);
	}

	// 修改产品类型
	static updateProductCategory(obj) {
		return postHttp(`${ TRAIN_URL }updateAllProducts`, obj, true, true);
	}

	// 删除产品类型
	static deleteProductCategory(obj) {
		return putHttp(`${ TRAIN_URL }deleteAllProducts`, obj, true, false);
	}

	// 获取ip小黑屋管理
	static findIpHouse(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findBlackHouseConfigure`, obj, true);
	}

	// 获取小黑屋禁闭人员
	static findIpConfiner(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findBlackHouseUser`, obj, true);
	}

	// 删除小黑屋禁闭人员
	static deleteIpConfiner(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/deleteBlackHouseUser`, obj, true, false);
	}

	// 修改ip小黑屋管理
	static updateIpHouse(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/updateBlackHouseConfigure`, obj, true, false);
	}

	// 获取门户网站一级分类
	static findWebPrimary(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findFuGatewaySort`, obj, true);
	}

	// 新增门户网站一级分类
	static addWebPrimary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/addFuGatewaySort`, obj, true, false);
	}

	// 修改门户网站一级分类
	static updateWebPrimary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/updateFuGatewaySort`, obj, true, false);
	}

	// 删除门户网站一级分类
	static deleteWebPrimary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/deleteFuGatewaySort`, obj, true, false);
	}

	// 获取门户网站二级分类
	static findWebSecondary(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findSonGatewaySort`, obj, true);
	}

	// 新增门户网站二级分类
	static addWebSecondary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/addSonGatewaySort`, obj, true, true);
	}

	// 修改门户网站二级分类
	static updateWebSecondary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/updateSonGatewaySort`, obj, true, true);
	}

	// 删除门户网站二级分类
	static deleteWebSecondary(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/deleteSonGatewaySort`, obj, true, false);
	}

	// 获取训练异常日志
	static findLogTraining(obj) {
		return postHttp(`${ LOG_URL }getTrainExceptionLogs`, obj, true, true);
	}

	// 获取充值消费统计
	static findLogCost(obj) {
		return postHttp(`${ LOG_URL }getRecAndConLogs`, obj, true, true);
	}

	// 获取充值消费统计
	static findLogUpdateTraining(obj) {
		return postHttp(`${ LOG_URL }getUpdateMissProLogs`, obj, true, true);
	}

	// 查看商城异常
	static findLogMallUnusual(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findRechargeHaoKan`, obj, true);
	}

	// 删除商城异常
	static deleteLogMallUnusual(obj) {
		return postHttp(`${ BACKSTAGE_URL }utils/deleteRechargeHaoKan`, obj, true, false);
	}

	// 查询客服角色
	static findCustomerRole(obj) {
		return getHttp(`${ BACKSTAGE_URL }findRoleByKefeiChat`, obj, true);
	}

	// 新增客服筛选条件
	static addCustomerCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }addUKefuServerCondition`, obj, true, true);
	}

	// 查询客服筛选条件
	static findCustomerCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }findUKefuServerCondition`, obj, true, true);
	}

	// 修改客服筛选条件
	static updateCustomerCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }updateUKefuServerCondition`, obj, true, true);
	}

	// 删除客服筛选条件
	static deleteCustomerCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }deleteUKefuServerCondition`, obj, true, false);
	}

	// 查询客服
	static findCustomer(obj) {
		return postHttp(`${ BACKSTAGE_URL }findServerByKefeiChat`, obj, true, true);
	}

	// 新增客服
	static addCustomer(obj) {
		return postHttp(`${ BACKSTAGE_URL }addServerByKefeiChat`, obj, true, true);
	}

	// 修改客服
	static updateCustomer(obj) {
		return postHttp(`${ BACKSTAGE_URL }updateServerByKefeiChat`, obj, true, true);
	}

	// 删除客服
	static deleteCustomer(obj) {
		return postHttp(`${ BACKSTAGE_URL }deleteServerByKefeiChat`, obj, true, false);
	}

	// 登录人员统计
	static findLoginCount() {
		return getHttp(`${ BACKSTAGE_URL }findLoginTypeNum`, {}, true);
	}

	// 账户续费查询
	static findAccountRenewal(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/findUserAccount`, obj, true, true);
	}

	// 重置任务难度
	static resetTaskDiff(obj) {
		return postHttp(`${ TRAIN_URL }resetMissionIndex`, obj, true, false);
	}

	// 查看充值账户异常
	static findRechargeAccountUnusual(obj) {
		return getHttp(`${ BACKSTAGE_URL }utils/findRechargeErrorVerAndPer`, obj, true);
	}

	// 新增病历
	static newMedical(obj) {
		return postHttp(`${ BACKSTAGE_URL }medical/addMedicalRecordUnified`, obj, true, true);
	}

	// 查看病历
	static viewMedical(obj) {
		return getHttp(`${ BACKSTAGE_URL }medical/getMedicalRecordById`, obj, true);
	}

	// 获取患者所有病历信息
	static findUserMedicalRecord(obj) {
		return getHttp(`${ BACKSTAGE_URL }medical/findAllMedicalRecordsInfo`, obj, true);
	}

	// 修改病历
	static updateMedical(obj) {
		return postHttp(`${ BACKSTAGE_URL }medical/updateMedicalRecordUnified`, obj, true, true);
	}

	// 删除病历
	static deleteMedical(obj) {
		return postHttp(`${ BACKSTAGE_URL }medical/deleteMedicalRecordUnified`, obj, true, false);
	}

	// 获取带训信息
	static findWithTraining(obj) {
		return getHttp(`${ TRAIN_URL }findEffectTimeList`, obj, true);
	}

	// // 新增带训信息
	// static newWithTraining(obj) {
	// 	return postHttp(`${ TRAIN_URL }addGuideTrainEffect`, obj, true, true);
	// }

	// 新增带训信息
	static newWithTraining(obj) {
		return postHttp(`${ LI_URL_TRAIN }compatible/old/addGuideTrainEffect`, obj, true, true);
	}

	// 修改带训信息
	static updateWithTraining(obj) {
		return postHttp(`${ TRAIN_URL }updateGuideTrainEffect`, obj, true, true);
	}

	// 删除带训信息
	static deleteWithTraining(obj) {
		return postHttp(`${ TRAIN_URL }deleteGuideTrainEffect`, obj, true, false);
	}

	// 获取带训信息小器械项目
	static getMaterials() {
		return getHttp(`${ TRAIN_URL }getSmallInstruments`, {}, true);
	}

	// 获取带训信息训练情况
	static getWithTrainingSituation(obj) {
		return getHttp(`${ TRAIN_URL }getPatientEvaluations`, obj, true);
	}

	// 根据日期获取带训信息
	static getWithTrainingInfoByDate(obj) {
		return getHttp(`${ TRAIN_URL }getTrainingInfoById`, obj, true);
	}

	// 查询带训师
	static queryTrainerByName(obj) {
		return getHttp(`${ BACKSTAGE_URL }operation/getAllTrainer`, obj, true);
	}

	// 获取处方异常日志
	static findLogPrescription(obj) {
		return postHttp(`${ LOG_URL }getPrescriptionLogs`, obj, true, true);
	}

	// 新增带训人
	static addTrainer(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/addTrainer`, obj, true, true);
	}

	// 删除带训人
	static deleteTrainer(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/deleteTrainerById`, obj, true, false);
	}

	// 条件查询带训人
	static findTrainerByCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/getTrainerByConditions`, obj, true, true);
	}

	// 根据账号查询带训人
	static getTrainerByCode(obj) {
		return getHttp(`${ BACKSTAGE_URL }operation/getTrainerByCode`, obj, true);
	}

	// 查询训练师下面的患者
	static findUsersByTrainer(obj) {
		return postHttp(`${ TRAIN_URL }findGuideDoctorTrain`, obj, true, true);
	}

	// 修改带训人
	static updateTrainer(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/updateTrainer`, obj, true, true);
	}

	// 查询异常训练
	static findAbnormalTrainingForUser(obj) {
		return postHttp(`${ TRAIN_URL }findAbnormalTrainUser`, obj, true, true);
	}

	// 查询用户异常训练详情
	static findAbnormalTrainingDetailByUser(obj) {
		return postHttp(`${ TRAIN_URL }findErrorAbnormalInfo`, obj, true, true);
	}

	// 查询用户出勤率
	static findAttendanceByUser(obj) {
		return postHttp(`${ VISION_URL }findUserTrainTime`, obj, true, false);
	}

	// 查询用户异常出勤日
	static findAbnormalAttendanceByUser(obj) {
		return postHttp(`${ TRAIN_URL }findUserErrorTrainTime`, obj, true, false);
	}

	// 查询用户当日训练
	static findSingleTrainingByDate(obj) {
		return getHttp(`${ TRAIN_URL }findBnormalInfoBySelectTime`, obj, true);
	}

	// 查询训练师带训信息
	static findDataByTrainer(obj) {
		return postHttp(`${ TRAIN_URL }findRootAgentGuideTrain`, obj, true, true);
	}

	// 删除日志
	static deleteLogs(obj) {
		return postHttp(`${ LOG_URL }deleteLogs`, obj, true, false);
	}

	// 查询患者备忘录
	static findUserMemos(obj) {
		return getHttp(`${ BACKSTAGE_URL }operation/findMemorandumById`, obj, true);
	}

	// 添加患者备忘录
	static addUserMemo(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/insertUmUserMemorandum`, obj, true, true);
	}

	// 修改患者备忘录
	static updateUserMemo(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/updateUmUserMemorandum`, obj, true, true);
	}

	// 删除患者备忘录
	static deleteUserMemo(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/deleteUmUserMemorandum`, obj, true, false);
	}

	// 根据条件查询患者备
	static findMemosByCondition(obj) {
		return postHttp(`${ BACKSTAGE_URL }operation/findUmUserMemorandum`, obj, true, true);
	}

	// 添加关联机构
	static addRelatedOrganization(obj) {
		return postHttp(`${ LI_URL }admin/buser-enterprise/save`, obj, true, true);
	}

	// 查询用户关联机构
	static findRelatedOrganizations(obj) {
		return getHttp(`${ LI_URL }admin/buser-enterprise/list`, obj, true);
	}

	// 删除关联机构
	static deleteRelatedOrganization(id) {
		return deleteHttp(`${ LI_URL }admin/buser-enterprise/${ id }`, {}, true);
	}

	// 根据关联机构获取对应权限
	static findPermissionByOrganization(obj) {
		return getHttp(`${ LI_URL }admin/buser-enterprise-priviledge/list`, obj, true);
	}

	// 更新关联机构获取对应权限
	static updatePermissionByOrganization(obj) {
		return postHttp(`${ LI_URL }admin/buser-enterprise-priviledge/save`, obj, true, true);
	}

	// 新增权限
	static addPermission(obj) {
		return postHttp(`${ LI_URL }admin/priviledge/save`, obj, true, true);
	}

	// 条件查询权限
	static findPermissionByCondition(obj) {
		return getHttp(`${ LI_URL }admin/priviledge/page`, obj, true);
	}

	// 修改权限
	static updatePermission(obj) {
		return postHttp(`${ LI_URL }admin/priviledge/update`, obj, true, true);
	}

	// 删除权限
	static deletePermission(id) {
		return deleteHttp(`${ LI_URL }admin/priviledge/${ id }`, {}, true);
	}

	// 查询患者任务
	static getUserTask(obj) {
		return postHttp(`${ TRAIN_URL }missionPatientInfo`, obj, true, true);
	}

	// 重置患者任务
	static resetUserTask(obj) {
		return postHttp(`${ TRAIN_URL }updateMissionIndex`, obj, true, false);
	}

	// 获取邀请奖励
	static getInviteReward(obj) {
		return getHttp(`${ LI_URL }admin/cr/recharge/inviteInfo`, obj, true);
	}

	// 获取代理商用户下属机构
	static findUnderlingOrganizations(obj) {
		return getHttp(`${ LI_URL }admin/buser-enterprise/backstage/list`, obj, true);
	}

	// 新增app商户
	static addAppMerchant(obj) {
		return postHttp(`${ LI_URL }admin/commercial/save`, obj, true, true);
	}

	// 修改app商户
	static updateAppMerchant(obj) {
		return postHttp(`${ LI_URL }admin/commercial/update`, obj, true, true);
	}

	// 获取app商务经理
	static findAppManager() {
		return getHttp(`${ LI_URL }admin/buser/list`, {}, true);
	}

	// 获取app商户列表
	static findAppMerchants(obj) {
		return getHttp(`${ LI_URL }admin/commercial/page`, obj, true);
	}

	// 获取所有app文章类型
	static findAppArticleTypes() {
		return getHttp(`${ LI_URL_APP }app/post-cat/list`, {}, true);
	}

	// 获取分页app文章类型
	static findAppArticleTypesByPage(obj) {
		return getHttp(`${ LI_URL_APP }app/post-cat/page`, obj, true);
	}

	// 获取app文章发布人
	static findAppArticlePublisher() {
		return getHttp(`${ LI_URL_APP }app/buser/list`, {}, true);
	}

	// 添加app文章类型
	static addAppArticleType(obj) {
		return postHttp(`${ LI_URL_APP }app/post-cat/save`, obj, true, true);
	}

	// 修改app文章类型
	static updateAppArticleType(obj) {
		return postHttp(`${ LI_URL_APP }app/post-cat/update`, obj, true, true);
	}

	// 删除app文章类型
	static deleteAppArticleType(id) {
		return deleteHttp(`${ LI_URL_APP }app/post-cat/${ id }`, {}, true);
	}

	// 获取app文章列表
	static findAppArticles(obj) {
		return getHttp(`${ LI_URL_APP }app/post/page`, obj, true);
	}

	// 查看app文章
	static viewAppArticle(id) {
		return getHttp(`${ LI_URL_APP }app/post/${ id }`, {}, true);
	}

	// 新增app文章
	static addAppArticle(obj) {
		return postHttp(`${ LI_URL_APP }app/post/save`, obj, true, true);
	}

	// 修改app文章
	static updateAppArticle(obj) {
		return postHttp(`${ LI_URL_APP }app/post/update`, obj, true, true);
	}

	// 删除app文章
	static deleteAppArticle(id) {
		return deleteHttp(`${ LI_URL_APP }app/post/${ id }`, {}, true);
	}

	// 添加app常见问题
	static addAppProblem(obj) {
		return postHttp(`${ LI_URL_APP }app/question/save`, obj, true, true);
	}

	// 查询app常见问题
	static findAppProblems(obj) {
		return getHttp(`${ LI_URL_APP }app/question/page`, obj, true);
	}

	// 修改app常见问题
	static updateAppProblem(obj) {
		return postHttp(`${ LI_URL_APP }app/question/update`, obj, true, true);
	}

	// 删除app常见问题
	static deleteAppProblem(id) {
		return deleteHttp(`${ LI_URL_APP }app/question/${ id }`, {}, true);
	}

	// 添加app和商城疾病
	static addDiseaseForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/disease-aritle/save`, obj, true, true);
	}

	// 修改app和商城疾病
	static updateDiseaseForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/disease-aritle/update`, obj, true, true);
	}

	// 删除app和商城疾病
	static deleteDiseaseForAppAndMall(id, obj) {
		return deleteHttp(`${ LI_URL_APP }app/disease-aritle/${ id }`, obj, true);
	}

	// 获取分页app和商城疾病
	static findDiseasePageForAppAndMall(obj) {
		return getHttp(`${ LI_URL_APP }app/disease-aritle/page`, obj, true);
	}

	// 获取app和商城疾病
	static findDiseaseForAppAndMall(obj) {
		return getHttp(`${ LI_URL_APP }app/disease-aritle/list`, obj, true);
	}

	// 新增app和商城商品
	static addGoodsForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/goods/save`, obj, true, true);
	}

	// 修改app和商城商品
	static updateGoodsForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/goods/update`, obj, true, true);
	}

	// 删除app和商城商品
	static deleteGoodsForAppAndMall(id, obj) {
		return deleteHttp(`${ LI_URL_APP }app/goods/${ id }`, obj, true);
	}

	// 获取app和商城商品
	static findGoodsForAppAndMall(obj) {
		return getHttp(`${ LI_URL_APP }app/goods/page`, obj, true);
	}

	// 获取app和商城订单
	static findOrderForAppAndMall(obj) {
		return getHttp(`${ LI_URL_APP }app/order-main/page`, obj, true);
	}

	// app和商城订单发货设置
	static setOrderSendForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/order-main/express`, obj, true, true);
	}

	// 修改app和商城订单
	static updateOrderForAppAndMall(obj) {
		return postHttp(`${ LI_URL_APP }app/order-main/payupdate`, obj, true, true);
	}

	// 获取app和商城训练产品列表
	static findTrainingProductForAppAndMall(obj) {
		return getHttp(`${ LI_URL_TRAIN }training/egl-product/list`, obj, true);
	}

	// 获取app疾病关联商品
	static findAppDiseaseAndGoods() {
		return getHttp(`${ LI_URL_APP }app/goods-disease/list`, {}, true);
	}

	// 新增app首页轮播
	static addAppHomeSwiper(obj) {
		return postHttp(`${ LI_URL_APP }app/banner/save`, obj, true, true);
	}

	// 获取app首页轮播
	static findAppHomeSwiper() {
		return getHttp(`${ LI_URL_APP }app/banner/list`, {}, true);
	}

	// 修改app首页轮播
	static updateAppHomeSwiper(obj) {
		return postHttp(`${ LI_URL_APP }app/banner/update`, obj, true, true);
	}

	// 删除app首页轮播
	static deleteAppHomeSwiper(id) {
		return deleteHttp(`${ LI_URL_APP }app/banner/${ id }`, {}, true);
	}

	// 获取app热门搜索
	static findAppHotSearch(obj) {
		return getHttp(`${ LI_URL_APP }app/hot-search/page`, obj, true);
	}

	// 新增app热门搜索
	static addAppHotSearch(obj) {
		return postHttp(`${ LI_URL_APP }app/hot-search/save`, obj, true, true);
	}

	// 修改app热门搜索
	static updateAppHotSearch(obj) {
		return postHttp(`${ LI_URL_APP }app/hot-search/update`, obj, true, true);
	}

	// 删除app热门搜索
	static deleteAppHotSearch(id) {
		return deleteHttp(`${ LI_URL_APP }app/hot-search/${ id }`, {}, true);
	}

	// 获取sim卡列表
	static findSims(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/sim-card/page`, obj, true);
	}

	// 修改sim卡
	static updateSim(obj) {
		return postHttp(`${ LI_URL_KDSL }kdsl/sim-card/update`, obj, true, true);
	}

	// 获取中频治疗仪
	static findIF(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/frequency-detector/page`, obj, true);
	}


	// 中频理疗仪-使用记录
	static consumptionpageNew(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/consumption/pageNew`, obj, true);
	}

	// 查看中频治疗仪详情
	static getIFDetail(id) {
		return getHttp(`${ LI_URL_KDSL }kdsl/frequency-detector/${ id }`, {}, true);
	}

	// 修改中频治疗仪
	static updateIF(obj) {
		return postHttp(`${ LI_URL_KDSL }kdsl/frequency-detector/update`, obj, true, true);
	}

	// 获取视觉检测设备
	static findVisualDetectionDevices(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/device/page`, obj, true);
	}

	// 新增视觉检测设备
	static addVisualDetectionDevice(obj) {
		return postHttp(`${ LI_URL_KDSL }kdsl/device/save`, obj, true, true);
	}

	// 修改视觉检测设备
	static updateVisualDetectionDevice(obj) {
		return postHttp(`${ LI_URL_KDSL }kdsl/device/update`, obj, true, true);
	}

	// 删除视觉检测设备
	static deleteVisualDetectionDevice(id) {
		return deleteHttp(`${ LI_URL_KDSL }kdsl/device/${ id }`, {}, true);
	}

	// 根据用户账号查询用户
	static findUserByCode(obj) {
		return getHttp(`${ LI_URL }getUserByUcode`, obj, true);
	}

	// 查询中频治疗仪消费记录
	static getConsumeRecordByIF(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/consumption/page`, obj, true);
	}

	// 查询中频治疗仪SIM卡记录
	static getSIMRecordByIF(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/open-log/page`, obj, true);
	}

	// 查询中频治疗仪治疗记录
	static getTreatmentRecordByIF(obj) {
		return getHttp(`${ LI_URL_KDSL }kdsl/grant-log/page`, obj, true);
	}

	// excel列表
	static findExcel(obj) {
		return getHttp(`${ LI_URL }admin/recharge-excel/page`, obj, true);
	}

	// excel赠送充值记录
	static findRecordByExcel(obj) {
		return getHttp(`${ LI_URL }admin/recharge-excel-detail/page`, obj, true);
	}

	// 查看excel
	static getDetailByExcelId(obj) {
		return getHttp(`${ LI_URL }admin/recharge-excel-detail/list`, obj, true);
	}

	// 上传文件
	static uploadFile(data) {
		return new Promise((resolve, reject) => {
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Authorization': 'Basic S2ZXZWJBcHA6S2ZXZWJBcHA=',
					'content-type': 'application/x-www-form-urlencoded'
				}
			};
			Axios.post(`${ LI_URL }file/no/file`, data, config).then((res) => {
				resolve(res);
			}).catch((e) => {
				reject({
					message: e.errMsg
				});
			});
		});
	}

	// 新增excel
	static addExcel(obj) {
		return postHttp(`${ LI_URL }admin/recharge-excel/save`, obj, true, true);
	}

	// 获取训练师
	static findTrainer() {
		return getHttp(`${ LI_URL }wx/cp/cpUser`, {}, true);
	}

	// 新增i练助手banner
	static addIAssistantBanner(obj) {
		return postHttp(`${ LI_URL_APP }yicong/banner/save`, obj, true, true);
	}

	// 获取i练助手banner
	static findIAssistantBanner() {
		return getHttp(`${ LI_URL_APP }yicong/banner/list`, {}, true);
	}

	// 修改i练助手banner
	static updateIAssistantBanner(obj) {
		return postHttp(`${ LI_URL_APP }yicong/banner/update`, obj, true, true);
	}

	// 删除i练助手banner
	static deleteIAssistantBanner(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/banner/${ id }`, {}, true);
	}

	// 新增微i练助手卡片
	static addIAssistantCard(obj) {
		return postHttp(`${ LI_URL_APP }yicong/card/save`, obj, true, true);
	}

	// 获取i练助手卡片
	static findIAssistantCardByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/card/page`, obj, true);
	}

	// 修改i练助手卡片
	static updateIAssistantCard(obj) {
		return postHttp(`${ LI_URL_APP }yicong/card/update`, obj, true, true);
	}

	// 删除i练助手卡片
	static deleteIAssistantCard(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/card/${ id }`, {}, true);
	}

	// 新增i练助手分类
	static addIAssistantSort(obj) {
		return postHttp(`${ LI_URL_APP }yicong/cat/save`, obj, true, true);
	}

	// 获取i练助手分类
	static findIAssistantSort() {
		return getHttp(`${ LI_URL_APP }yicong/cat/list`, {}, true);
	}

	// 获取i练助手分类（分页）
	static findIAssistantSortByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/cat/page`, obj, true);
	}

	// 修改i练助手分类
	static updateIAssistantSort(obj) {
		return postHttp(`${ LI_URL_APP }yicong/cat/update`, obj, true, true);
	}

	// 删除i练助手分类
	static deleteIAssistantSort(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/cat/${ id }`, {}, true);
	}

	// 新增i练助手成功案例
	static addIAssistantCase(obj) {
		return postHttp(`${ LI_URL_APP }yicong/case/save`, obj, true, true);
	}

	// 获取i练助手成功案例
	static findIAssistantCaseByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/case/page`, obj, true);
	}

	// 修改i练助手成功案例
	static updateIAssistantCase(obj) {
		return postHttp(`${ LI_URL_APP }yicong/case/update`, obj, true, true);
	}

	// 删除i练助手成功案例
	static deleteIAssistantCase(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/case/${ id }`, {}, true);
	}

	// 新增i练助手科普社区
	static addIAssistantCommunity(obj) {
		return postHttp(`${ LI_URL_APP }yicong/science/save`, obj, true, true);
	}

	// 获取i练助手科普社区
	static findIAssistantCommunityByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/science/page`, obj, true);
	}

	// 修改i练助手科普社区
	static updateIAssistantCommunity(obj) {
		return postHttp(`${ LI_URL_APP }yicong/science/update`, obj, true, true);
	}

	// 删除i练助手科普社区
	static deleteIAssistantCommunity(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/science/${ id }`, {}, true);
	}

	// 新增i练助手科普知识
	static addIAssistantKnowledge(obj) {
		return postHttp(`${ LI_URL_APP }yicong/knowledge/save`, obj, true, true);
	}

	// 获取i练助手科普知识
	static findIAssistantKnowledgeByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/knowledge/page`, obj, true);
	}

	// 修改i练助手科普知识
	static updateIAssistantKnowledge(obj) {
		return postHttp(`${ LI_URL_APP }yicong/knowledge/update`, obj, true, true);
	}

	// 删除i练助手科普知识
	static deleteIAssistantKnowledge(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/knowledge/${ id }`, {}, true);
	}

	// 新增i练助手网课
	static addIAssistantCourse(obj) {
		return postHttp(`${ LI_URL_APP }yicong/wangke/save`, obj, true, true);
	}

	// 获取i练助手网课
	static findIAssistantCourseByPage(obj) {
		return getHttp(`${ LI_URL_APP }yicong/wangke/page`, obj, true);
	}

	// 修改i练助手网课
	static updateIAssistantCourse(obj) {
		return postHttp(`${ LI_URL_APP }yicong/wangke/update`, obj, true, true);
	}

	// 删除i练助手网课
	static deleteIAssistantCourse(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/wangke/${ id }`, {}, true);
	}

	// 获取i练助手积分兑换列表
	static findIAssistantIntegralExchanges(obj) {
		return getHttp(`${ LI_URL_APP }yicong/pointsExchange/page`, obj, true);
	}

	// 添加i练助手积分兑换
	static addIAssistantIntegralExchange(obj) {
		return postHttp(`${ LI_URL_APP }yicong/pointsExchange/save`, obj, true, true);
	}

	// 修改i练助手积分兑换
	static updateIAssistantIntegralExchange(obj) {
		return postHttp(`${ LI_URL_APP }yicong/pointsExchange/update`, obj, true, true);
	}

	// 删除i练助手积分兑换
	static deleteIAssistantIntegralExchange(id) {
		return deleteHttp(`${ LI_URL_APP }yicong/pointsExchange/${ id }`, {}, true);
	}

	// 获取i练助手积分记录列表
	static findIAssistantIntegralRecords(obj) {
		return getHttp(`${ LI_URL_APP }yicong/pointRecord/page`, obj, true);
	}

	// 新增i练助手积分记录
	static addIAssistantIntegralRecord(obj) {
		return postHttp(`${ LI_URL_APP }yicong/pointRecord/save`, obj, true, true);
	}

	// 根据用户获取AI报告列表
	static findAIReportByUser(obj) {
		return getHttp(`${ LI_URL }visualplatpad/detector-report/admin/getReportUserId`, obj, true);
	}

	// 获取AI报告详情
	static getDetailForAIReport(id) {
		return getHttp(`${ LI_URL }visualplatpad/detector-report/${ id }`, {}, true);
	}

	// 设置代理商
	static setAgent(obj) {
		return postHttp(`${ LI_URL_TRAIN }training/admin/card/updateByEnterpriseName`, obj, true, true);
	}

	// 设置卡片状态
	static setCardState(obj) {
		return postHttp(`${ LI_URL_TRAIN }training/admin/card/updateByCardSmallType`, obj, true, true);
	}

	// 获取代理商
	static findAllAgent(obj) {
		return getHttp(`${ LI_URL_TRAIN }training/enterprise-view/list`, obj, true);
	}
	// 根据查询条件获取分页卡片
	static findCardByPageAndCondition(obj) {
		return getHttp(`${ LI_URL_TRAIN }training/admin/card/page`, obj, true);
	}

	// 卡片生成分页查询
	static findCardGenerateByPageAndCondition(obj) {
		return getHttp(`${ LI_URL_TRAIN }training/generatorCard/page`, obj, true);
	}


	// 卡片转出记录
	static cardtransferHistory(obj) {
		return getHttp(`${ LI_URL_TRAIN }training/admin/card/transferHistory`, obj, true);
	}

	// 新增卡片生成
	static addCardGenerate(obj) {
		return postHttp(`${ LI_URL_TRAIN }training/generatorCard/save`, obj, true, true);
	}

	// 导出卡片生成
	static exportCardGenerate(id) {
		return getHttp(`${ LI_URL_TRAIN }training/generatorCard/getExcelDataById/${ id }`, {}, true);
	}

	// 卡片激活
	static activeCard(obj) {
		return postHttp(`${ LI_URL_TRAIN }front/cardRegisterAdmin`, obj, true, true);
	}
	//更新机构卡接口
	static updateNewCard(obj) {
		return postHttp(`${ LI_URL }admin/enterprise/updateNewCard`, obj, true, true);
	}
	// ------滤波镜片----------
	//add添加滤波镜片
	static lensOrderSave(obj) {
		return postHttp(`${ LI_URL }cust-order/save`, obj, true, true);
	}
	//订单状态修改
	static lensOrderUpdate(obj) {
		let {coinDetailId,orderStatus}=obj
		return putHttp(`${LI_URL}cust-order/updateStatus/${coinDetailId}/${orderStatus}`, {}, true, true)
	
	}
	//订单重新绑定检测
	static updateTest(obj) {
		let {coinDetailId,testId,testCreateTs}=obj
		return putHttp(`${LI_URL}cust-order/updateTest`, obj, true, true)
	
	}
	//
	static lensOrderList(obj) {
		return getHttp(`${ LI_URL }cust-order/page`, obj, true, true);
	}
	//获取报告
	static reportListAdmin(obj) {
		return getHttp(`${ LI_URL }v5/device/v30-detector-report/reportListOldAdmin`, obj, true, true);
	}
	//获取地址
	static getAdss(id) {
		return postHttp(`${ LI_URL }customer/customer-delivery-info/no/${ id }`, {}, true);
	}
	// 发货
	static lensSend(params) {
		return putHttp(`${ LI_URL }cust-order/send/${ params.orderId }`, params, true, true);
	}

	/* 
	赠送用户 
	 */
	static giftUser(params) {
		return getHttp(`${LI_URL_TRAIN}training/product-patient-relative/yesterday-recharge-bonus`, params, true, true);
	}
}